import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Select, DatePicker } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import SelectProvince from '../../../common/SelectProvince';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import format from '../../../shared/format';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class ColorFilter extends Component {
    static contextTypes = {
        activeKey: PropTypes.string,
        business: PropTypes.array,
        contractType: PropTypes.array,
        systemDate: PropTypes.object,
        area: PropTypes.object,
    }

    state={
        area:[]
    }

    handleChange = (value, key) => {
        const { params, onChange } = this.props;
        switch (key) {
            case 'contractTypeId': {
                if ((value || []).length === 0) {
                    return;
                }
                params[key] = (value || []).length ? value.join(',') : '';
                break;
            }
            case 'leader': 
            case 'disease':{
                const { value: id, text: name } = value;
                params[`${key}Id`] = id;
                params[`${key}Name`] = name;
                break;
            }
            case 'province': {
                const areaParams = {};
                const areaList = [];
                const hasCheckedArea = [];
                value.forEach(item => {
                    const { key, props: { title } = {} } = item || {};
                    areaParams[`params[${title}]`] = key;
                    areaList.push(title);
                    hasCheckedArea.push(key);
                });
                params.areaParams = areaParams;
                params.hasCheckedArea = hasCheckedArea;
                params.areaName = areaList.join(',');
                break;
            }
            case 'investigationAreaId' :{
                params[key] = value;
                if(!value) {
                    params.diseaseName = undefined;
                    params.diseaseId = undefined;
                }
                break;
            }
            default:
                params[key] = value;
                break;
        }
        onChange(params);
    }

    disabledDate = (current) => {
        const { systemDate: { date } = {} } = this.context;
        const value = moment(format('month', date)).add(1, 'M').valueOf();
        return current && current.valueOf() >= value;
    }

    render() {
        const { activeKey, business, contractType, systemDate: { trueYear }, area } = this.context;
        const { params, onSearch, onExport } = this.props;
        const businessOption = business
            .filter(i => i.groupId !== 2)
            .map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const areaOption = area.map(i => <Option key={i.investigationAreaId}>{i.investigationAreaName}</Option>);
        return (
            <div className="filter-wrap" style={{ marginBottom: 10, padding: 10, paddingBottom: 0, background: '#fff' }}>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">业务线</label>
                    <Select
                        placeholder="请选择"
                        value={format('toString', params.lineOfBusiness)}
                        style={{ width: 80, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">项目领域</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{ width: 120 }}
                        value={params.investigationAreaId}
                        onChange={value => this.handleChange(value, 'investigationAreaId')}
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="filter-item">
                    <label className="filter-label">疾病</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 100 }}
                        params={{ investigationAreaId: params.investigationAreaId , limit: 20}}
                        placeholder="输入名称检索"
                        url={API_URL.common.queryAllDisease}
                        value={params.diseaseName}
                        disabled={!params.investigationAreaId}
                        config={{ id: 'diseaseId', name: 'diseaseName' }}
                        onChange={(option) => this.handleChange(option, 'disease')}
                    />
                </div>
                <div className="filter-item">
                    <label className="filter-label">团队领导</label>
                    <SearchRetrieve
                        keyword='nameCode'
                        style={{ width: 140 }}
                        params={{ limit: 20}}
                        placeholder="输入姓名或工号检索"
                        url={API_URL.user.getAllCRCDeptUserList}
                        value={params.leaderName}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'  }}
                        onChange={(option) => this.handleChange(option, 'leader')}
                    />
                </div>
                <div className="filter-item">
                    <label className="filter-label">区域/城市</label>
                    <SelectProvince
                        placeholder={'请选择'}
                        areaName={params.areaName || ''}
                        saveProvince={value => this.handleChange(value, 'province')}
                        hasCheckedArea={params.hasCheckedArea || []}
                        style={{verticalAlign: 'middle', width:'100px'}}
                    />
                </div>
                <div className="filter-item">
                    <label className="filter-label">统计时间</label>
                    <MonthPicker
                        format={monthFormat}
                        allowClear={false}
                        disabledDate={this.disabledDate}
                        value={format('toMoment', params.date)}
                        onChange={(date, dateString) => this.handleChange(dateString, 'date')}
                        style={{width: 100, verticalAlign: 'middle'}}
                    />
                </div>
                <div className="filter-item">
                    <Button type="primary" onClick={onSearch}>统计</Button>
                    <Button className="btn-yellow" style={{ marginLeft: 10 }} onClick={onExport}>明细导出</Button>
                </div>
            </div>
        );
    }
}

export default ColorFilter;



// WEBPACK FOOTER //
// ./src/components/homePage/personIndicatorAnalysis/components/ColorFilter.js